import { useState, useEffect } from "react";
import { Search } from "lucide-react";
import { Input } from "@/marketing/components/ui/input";
import { useDebounce } from "@/marketing/hooks/useDebounce";
import { useFilterStore } from "@/marketing/stores/useFilterStore";

export function TextSearchFilter() {
  const search = useFilterStore((s) => s.filters.search);
  const setSearch = useFilterStore((s) => s.setSearch);
  const [localValue, setLocalValue] = useState(search);
  const debouncedValue = useDebounce(localValue, 300);

  useEffect(() => {
    setSearch(debouncedValue);
  }, [debouncedValue, setSearch]);

  useEffect(() => {
    setLocalValue(search);
  }, [search]);

  return (
    <div className="tw-relative">
      <Search className="tw-absolute tw-left-3 tw-top-1/2 tw-h-4 tw-w-4 -tw-translate-y-1/2 tw-text-muted-foreground" />
      <Input
        placeholder="Search by handle or name..."
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        className="tw-pl-9 tw-w-[260px]"
      />
    </div>
  );
}
